import { ArrowRestorePrimaryIcon, TrashCanPrimaryIcon } from '@assets/iconComponents';
import { check_circle_primary } from '@assets/icons';
import {
  DeletedImageModal,
  GuideModal,
  AdminMenuTop,
  AdminNavigation,
  Pagination,
  SecureImage,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableWrapper,
  Text
} from '@components';
import { CategorySelectEnum, AdminModalType, styleConstant } from '@constant';
import { useAdminDeletedImageList } from '@hooks';
import { colorSet } from '@theme';

const DeletedImageListPage = () => {
  const {
    tableHeader,
    response,
    page,
    handlePageChange,

    handleTargetClick,
    handleDeletedImageModalOpen,
    handleDeletedImageModalClose,

    targetInfo,
    modalType,
    isModalVisible,
    handleRestoreButtonClick,
    handleHardDeleteButtonClick,
    handleModalConfirmClick,
    handleModalClose,

    isRestorePending,
    isHardDeletePending
  } = useAdminDeletedImageList();

  const createModalTitle = () => {
    if (modalType === AdminModalType.RESTORE_CONFIRM) {
      return '이미지를 복구하시겠습니까?';
    } else if (modalType === AdminModalType.HARD_DELETE_CONFIRM) {
      return '이미지를 영구적으로 삭제하시겠습니까?';
    } else if (
      modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
      modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
    ) {
      return '복구가 완료되었습니다.';
    } else if (modalType === AdminModalType.RESTORE_FAIL) {
      return '복구에 실패했습니다.';
    } else if (modalType === AdminModalType.HARD_DELETE_FAIL) {
      return '영구 삭제에 실패했습니다.';
    } else {
      return '';
    }
  };

  const createModalContent = () => {
    if (modalType === AdminModalType.RESTORE_CONFIRM) {
      return '복구된 이미지는 시퀀스의 마지막 컷으로 추가됩니다.';
    } else if (modalType === AdminModalType.HARD_DELETE_CONFIRM) {
      return `${targetInfo?.originFileName}
      파일이 완전히 삭제되며, 이 작업은 되돌릴 수 없습니다.`;
    } else if (modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS) {
      return `선택하신 이미지는 ‘스탠다드 검색 이미지 리스트’에 복구되었습니다.
      지금 확인하시겠습니까?`;
    } else if (modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS) {
      return `선택하신 이미지는 ‘19금 이미지 리스트’에 복구되었습니다.
      지금 확인하시겠습니까?`;
    } else if (modalType === AdminModalType.RESTORE_FAIL || modalType === AdminModalType.HARD_DELETE_FAIL) {
      return '요청이 실패하였습니다. 다시 시도해주세요.';
    } else {
      return '';
    }
  };

  const createModalButtonText = () => {
    if (modalType === AdminModalType.RESTORE_CONFIRM) {
      return '복구하기';
    } else if (modalType === AdminModalType.HARD_DELETE_CONFIRM) {
      return '영구 삭제';
    } else if (
      modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
      modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
    ) {
      return '복구된 이미지 확인하기';
    } else {
      return '확인';
    }
  };

  const createModalButtonVariant = () => {
    if (
      modalType === AdminModalType.RESTORE_CONFIRM ||
      modalType === AdminModalType.HARD_DELETE_CONFIRM ||
      modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
      modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
    ) {
      return 'contained';
    } else {
      return 'outlined';
    }
  };

  const createModalButtonCount = () => {
    if (
      modalType === AdminModalType.RESTORE_CONFIRM ||
      modalType === AdminModalType.HARD_DELETE_CONFIRM ||
      modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
      modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
    ) {
      return 2;
    } else {
      return 1;
    }
  };

  const createModalCancelButtonText = () => {
    if (
      modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
      modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
    ) {
      return '목록에 머무르기';
    } else {
      return '취소하기';
    }
  };

  return (
    <>
      <AdminMenuTop />

      <div style={{ display: 'flex' }}>
        <AdminNavigation />

        <div
          className="hide-scrollbar"
          style={{
            width: '100%',
            height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            padding: '48px 40px 96px 40px',
            overflowY: 'auto'
          }}
        >
          <Text variant="h2" fontWeight="bold" marginBottom="8px">
            삭제된 이미지 리스트
          </Text>
          <Text variant="body1" marginBottom="40px">
            삭제된 이미지는 최대 30일간 보관되며, 이후 자동으로 영구 삭제됩니다.
          </Text>

          <TableWrapper width="100%">
            <Table width="100%">
              <TableHeader>
                {tableHeader.map((header, key) => (
                  <TableHeaderItem key={key} width={header.width}>
                    <Text color="white" fontWeight="bold" align="center">
                      {header.label}
                    </Text>
                  </TableHeaderItem>
                ))}
              </TableHeader>
              <TableBody>
                {response?.data && response?.data.length > 0
                  ? response.data.map((row, key) => (
                      <TableRow
                        key={key}
                        onClick={() => {
                          handleDeletedImageModalOpen(row.id, row.theme, row.originFileName, row.sequence?.id);
                        }}
                        style={{ cursor: 'pointer' }}
                        hideBorderBottom={Boolean(
                          response.data[key].sequence &&
                            response.data[key + 1] &&
                            response.data[key + 1].sequence &&
                            response.data[key].sequence?.id === response.data[key + 1].sequence?.id
                        )}
                      >
                        <TableCell width={tableHeader[0].width}>
                          <Text align="center">{row.sequence?.id ? `${row.id}-${row.sequence.id}` : row.id}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[1].width} padding="0px 12px" justifyContent="flex-start">
                          <Text align="left">{CategorySelectEnum[row.theme]}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[2].width} padding="0px 12px" justifyContent="flex-start">
                          <Text align="left">{row.comic?.genre}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[3].width} padding="8px 12px">
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div
                              style={{
                                width: 42,
                                height: 56,
                                border: `1px solid ${colorSet.gray300}`,
                                borderRadius: '3px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: '12px'
                              }}
                            >
                              <SecureImage
                                imageUrl={row.s3Url ?? ''}
                                imageStyle={{ width: 34, height: 48, objectFit: 'contain' }}
                              />
                            </div>
                            <div
                              style={{
                                width: tableHeader[3].width - 78,
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start'
                              }}
                            >
                              <Text
                                align="left"
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  width: '100%'
                                }}
                              >
                                {row.originFileName}
                              </Text>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell
                          width={tableHeader[4].width}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          style={{ cursor: 'default' }}
                        >
                          <ArrowRestorePrimaryIcon
                            onClick={() => {
                              handleTargetClick(row.id, row.theme, row.originFileName, row.sequence?.id);
                              handleRestoreButtonClick();
                            }}
                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                          />
                        </TableCell>
                        <TableCell
                          width={tableHeader[5].width}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          style={{ cursor: 'default' }}
                        >
                          <TrashCanPrimaryIcon
                            onClick={() => {
                              handleTargetClick(row.id, row.theme, row.originFileName, row.sequence?.id);
                              handleHardDeleteButtonClick();
                            }}
                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  : []}
              </TableBody>
            </Table>
          </TableWrapper>

          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
              <Text variant="body1">Total</Text>
              <Text variant="subtitle" fontWeight="bold">
                {response?.meta?.itemCount ?? 0}
              </Text>
            </div>
            <Pagination page={page} pageCount={response?.meta?.pageCount ?? 0} onChange={handlePageChange} />
          </div>
        </div>
      </div>

      <DeletedImageModal
        onClose={handleDeletedImageModalClose}
        onRestoreButtonClick={handleRestoreButtonClick}
        onHardDeleteButtonClick={handleHardDeleteButtonClick}
        isPending={isRestorePending || isHardDeletePending}
      />

      <GuideModal
        isVisible={isModalVisible}
        onClick={handleModalConfirmClick}
        onClose={() => {
          handleModalClose();

          // 복구 성공 모달에서 '목록에 머무르기' 클릭시 추가적인 요청 막기 위해 삭제된 이미지 모달을 닫기
          if (
            modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
            modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
          ) {
            handleDeletedImageModalClose();
          }
        }}
        imgSrc={
          modalType === AdminModalType.RESTORE_STANDARD_IMAGE_SUCCESS ||
          modalType === AdminModalType.RESTORE_ADULTS_ONLY_IMAGE_SUCCESS
            ? check_circle_primary
            : undefined
        }
        title={createModalTitle()}
        content={createModalContent()}
        buttonText={createModalButtonText()}
        buttonVariant={createModalButtonVariant()}
        buttonCount={createModalButtonCount()}
        cancelButtonText={createModalCancelButtonText()}
        isPending={isRestorePending || isHardDeletePending}
      />
    </>
  );
};

export default DeletedImageListPage;
